import { AppSidebar, AppHeader } from '@/components'
import router from '@/router'

export const routes = [
  {
    path: '/cashflow-forecast-integration',
    name: 'cashflow-forecasting-integration',
    meta: {
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    components: {
      default: () => import('./cashflowForecastIntegration.vue'),
      header: AppHeader,
      sidebar: AppSidebar
    }
  },
  {
    path: '/cashflow-forecast',
    name: 'cashflow-forecast',
    meta: {
      sitemap: {
        title: 'Cash flow & forecasting',
        description: 'Predict future cash flow (requires accounting connection)',
        conditions: {
          all: [{ fact: 'portal', path: '$.enableCashFlowForecasting', operator: 'equal', value: true }]
        }
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    components: {
      default: () => import('./cashflowForecast.vue'),
      header: AppHeader,
      sidebar: AppSidebar
    }
  }
]

export default () => {
  routes.forEach(route => router.addRoute(route))
}
